var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "makeProcess layerpopup",
    class: {
      'active': _vm.visibility
    }
  }, [_c('div', {
    staticClass: "contentWrap"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("분류")]), _c('div', {
    staticClass: "field"
  }, _vm._l(_vm.fieldSelected, function (field, index) {
    return _c('FieldSelector', {
      attrs: {
        "placeholder": "분야를 선택해 주세요",
        "options": field,
        "data-valid": !_vm.fieldValues[index] ? true : false,
        "selected": _vm.fieldValues[index] ? _vm.fieldValues[index] : 0,
        "disabled": _vm.fieldEditFlag,
        "publicFlag": _vm.publicFlag
      },
      on: {
        "dataChange": function (item) {
          return _vm.changeField(item, index);
        }
      }
    });
  }), 1), _c('h3', [_vm._v("기술분류")]), _c('div', {
    staticClass: "field"
  }, _vm._l(_vm.knsccSelected, function (knscc, index) {
    return _c('FieldSelector', {
      attrs: {
        "placeholder": "국가과학기술표준분류를 선택해 주세요",
        "options": knscc,
        "data-valid": !_vm.knsccValues[index] ? true : false,
        "selected": _vm.knsccValues[index] ? _vm.knsccValues[index] : 0,
        "disabled": _vm.knsccEditFlag,
        "publicFlag": _vm.publicFlag
      },
      on: {
        "dataChange": function (item) {
          return _vm.changeKnscc(item, index);
        }
      }
    });
  }), 1), this.projectType === 'protocol' && this.actionType == 'make' && this.onlyProtocolFlag ? _c('div', {
    staticClass: "fieldType"
  }, [_c('h3', [_vm._v("구분선택")]), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkType,
      expression: "checkType"
    }],
    attrs: {
      "type": "radio",
      "name": "fiedType",
      "value": "FULL"
    },
    domProps: {
      "checked": _vm._q(_vm.checkType, "FULL")
    },
    on: {
      "change": function ($event) {
        _vm.checkType = "FULL";
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Full")])]), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkType,
      expression: "checkType"
    }],
    attrs: {
      "type": "radio",
      "name": "fiedType",
      "value": "UNIT"
    },
    domProps: {
      "checked": _vm._q(_vm.checkType, "UNIT")
    },
    on: {
      "change": function ($event) {
        _vm.checkType = "UNIT";
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Unit")])])]) : _vm._e(), _vm.checkType == 'UNIT' && _vm.Type === 'protocol|make' ? _c('div', {
    staticClass: "fieldType"
  }, [_c('h3', [_vm._v("유닛선택")]), _c('NodeSelector', {
    attrs: {
      "parentNodes": _vm.parentNodes
    },
    on: {
      "change": function (item) {
        return _vm.selectParentNode(item);
      }
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "processName"
  }, [_c('h3', [_vm._v(_vm._s(this.projectType == 'process' ? '공정도' : '프로토콜') + "명")]), _c('div', [_c('h4', [_vm._v("국문")]), _c('div', {
    staticClass: "editor",
    attrs: {
      "data-valid": this.titleKR === false ? true : false
    }
  }, [_c('editor-content', {
    attrs: {
      "editor": _vm.textEditorKR
    }
  })], 1), _c('button', {
    on: {
      "click": function ($event) {
        _vm.textEditorKR.chain().focus().toggleSuperscript().run();
      }
    }
  }, [_vm._v("위"), _c('br'), _vm._v("첨자")]), _c('button', {
    on: {
      "click": function ($event) {
        _vm.textEditorKR.chain().focus().toggleSubscript().run();
      }
    }
  }, [_vm._v("아래"), _c('br'), _vm._v("첨자")])]), _c('div', [_c('h4', [_vm._v("영문")]), _c('div', {
    staticClass: "editor",
    attrs: {
      "data-valid": this.titleEN === false ? true : false
    }
  }, [_c('editor-content', {
    attrs: {
      "editor": _vm.textEditorEN
    }
  })], 1), _c('button', {
    on: {
      "click": function ($event) {
        _vm.textEditorEN.chain().focus().toggleSuperscript().run();
      }
    }
  }, [_vm._v("위"), _c('br'), _vm._v("첨자")]), _c('button', {
    on: {
      "click": function ($event) {
        _vm.textEditorEN.chain().focus().toggleSubscript().run();
      }
    }
  }, [_vm._v("아래"), _c('br'), _vm._v("첨자")])])])]), _c('div', {
    staticClass: "ctrl"
  }, [this.actionType == 'make' ? _c('button', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("생성하기")]) : _c('button', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("수정하기")])]), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("닫기")])]), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }